import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../contexts/AuthContext';

/**
 * Keeps i18next language in sync with AuthContext.preferredLanguage.
 * Also sets document.documentElement.lang for WCAG 3.1.1 (Language of Page).
 */
export default function useLanguageSync() {
  const { preferredLanguage } = useAuth();
  const { i18n } = useTranslation();

  useEffect(() => {
    if (i18n.language !== preferredLanguage) {
      i18n.changeLanguage(preferredLanguage);
    }
    document.documentElement.lang = preferredLanguage;
  }, [preferredLanguage, i18n]);
}
